// ReasonSelect.tsx
import Select from 'react-select'
import {LoadingSpinner} from '../../../../utils/loading/loadingSpinner'
import {ISelect} from '../../../../coreGlobal/models/default'

interface ReasonSelectProps {
  options: ISelect[]
  reason?: ISelect | null
  setReason: (value: ISelect | null) => void
  observation: string
  setObservation: (value: string) => void
  openObservation: boolean
  setOpenObservation: (value: boolean) => void
}

const ReasonSelect = ({
  options,
  reason,
  setReason,
  observation,
  setObservation,
  openObservation,
  setOpenObservation,
}: ReasonSelectProps) => {
  return (
    <>
      <div className='column col-lg-4 mb-6'>
        <label className='col-lg-12 col-form-label fw-bold fs-6'>
          <span>Motivo cancelamento?</span>
        </label>
        <div className='col-lg-10 fv-row'>
          <Select
            id={`howMet`}
            className='react-select-styled react-select-solid '
            classNamePrefix='react-select'
            onChange={(option) => {
              setReason(option!)
              setOpenObservation(option?.observation_required ?? false)
            }}
            options={options}
            value={reason}
            placeholder='Selecione'
          />
        </div>
      </div>
      {openObservation && (
        <div className='column col-lg-6 mb-10'>
          <label className='col-lg-12 col-form-label fw-bold fs-6'>
            <span>Observação</span>
          </label>
          <div className='col-lg-10 fv-row'>
            <textarea
              className='form-control'
              aria-label='With textarea'
              onChange={(e) => setObservation(e.target.value)}
            ></textarea>
            {observation.length < 10 && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>Mínimo 10 caracteres</span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default ReasonSelect
